import * as React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Target } from "lucide-react";

const StudentPredictionsCards = ({ rankingData }) => {
  const metrics = [
    {
      value: rankingData.predictions?.attendanceNeeded || 0,
      label: "Days Attendance",
      color: "text-red-600 dark:text-red-400",
      bgColor: "bg-red-50 dark:bg-red-900/40",
    },
    {
      value: rankingData.predictions?.assignmentsNeeded || 0,
      label: "Assignments",
      color: "text-blue-600 dark:text-blue-400",
      bgColor: "bg-blue-50 dark:bg-blue-900/40",
    },
    {
      value: rankingData.predictions?.interviewsNeeded || 0,
      label: "Interviews",
      color: "text-purple-600 dark:text-purple-400",
      bgColor: "bg-purple-50 dark:bg-purple-900/40",
    },
    {
      value: rankingData.predictions?.tasksNeeded || 0,
      label: "Tasks",
      color: "text-amber-600 dark:text-amber-400",
      bgColor: "bg-amber-50 dark:bg-amber-900/40",
    },
  ];

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2.5">
          <div className="p-2 bg-blue-50 rounded-lg">
            <Target className="w-4 h-4 text-blue-600" />
          </div>
          <CardTitle className="text-base font-semibold text-foreground">
            Goals to Reach Next Rank
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-4 transition-colors duration-300">
        {/* Metric cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {metrics.map((metric, index) => (
            <div
              key={index}
              className={`${metric.bgColor} rounded-xl p-4 transition-all hover:scale-105 hover:shadow-md 
        dark:hover:shadow-lg dark:border dark:border-gray-700`}
            >
              <div
                className={`text-3xl font-bold ${metric.color} mb-1.5 transition-colors 
          dark:text-gray-100`}
              >
                {metric.value}
              </div>
              <div className="text-xs font-medium text-gray-600 dark:text-gray-400">
                {metric.label}
              </div>
            </div>
          ))}
        </div>

        {/* Next Target Score card */}
        <div
          className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 
    rounded-xl p-4 border border-transparent dark:border-gray-700 transition-all"
        >
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Next Target Score
            </span>
            <div className="flex items-baseline gap-1">
              <span className="text-2xl font-bold text-blue-600 dark:text-blue-400">
                {rankingData.predictions?.nextRankScore || 0}
              </span>
              <span className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                %
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StudentPredictionsCards;
